export const ITEMS = {
  PLC: "PLC"
};

export const retrievePLCs = (): Array<any> => {
  let result: Array<string> = [];
  const plcs = localStorage.getItem(ITEMS.PLC);
  if (plcs && Array.isArray(JSON.parse(plcs))) {
    result = JSON.parse(plcs);
  }
  return result;
};

export const getSortedPlcList = (): Array<string> => {
  return (
    retrievePLCs()
      ?.map((plc) => plc?.itemData?.itemCode)
      ?.sort((a: any, b: any) => a.localeCompare(b)) || []
  );
};

/** Trims and upper-cases a PLC code; catalog item codes are stored uppercase. */
export const normalizePlc = (plc: unknown): string => (typeof plc === "string" ? plc.trim().toUpperCase() : "");

/** Case-insensitive lookup of a PLC in the catalog list; returns the catalog's own value, or "" when unknown. */
export const findCatalogPlc = (catalogPlcs: Array<string>, plc: unknown): string => {
  const target = normalizePlc(plc);
  return target ? (catalogPlcs.find((item) => normalizePlc(item) === target) ?? "") : "";
};

export const storePLCs = (plcs: Array<string>) => {
  localStorage.setItem(ITEMS.PLC, plcs?.length ? JSON.stringify(plcs) : "");
};

export const getSortedReleasePlcList = (): Array<string> => {
  return (
    retrievePLCs()
      ?.filter((plc) => plc?.classification === "SP")
      ?.map((plc) => plc?.itemData?.itemCode)
      ?.sort((a: any, b: any) => a.localeCompare(b)) || []
  );
};

export const clearPLCs = () => {
  localStorage.removeItem(ITEMS.PLC);
};
